import type { QuestionAnswer } from "@mux/sdk/v2/client"
import type { ServerConnection } from "@/context/server"
import { workspaceHeaders } from "@/sdk/v2/workspace"
import type { TransportFetch } from "./http"
import { requestReply } from "./request-replies"
import { serverFetch } from "./server"

/** Answers a question, or dismisses it when answers is undefined. */
export async function respondToQuestion(
  server: ServerConnection.HttpBase,
  directory: string,
  requestID: string,
  answers: QuestionAnswer[] | undefined,
  options?: { signal?: AbortSignal; fetch?: TransportFetch },
) {
  const action = answers === undefined ? "reject" : "reply"
  return requestReply(await serverFetch(server, `/question/${encodeURIComponent(requestID)}/${action}`, {
    method: "POST",
    headers: { ...workspaceHeaders(directory), "Content-Type": "application/json" },
    body: answers === undefined ? undefined : JSON.stringify({ answers }),
    signal: options?.signal,
  }, options), "Server did not acknowledge the question response")
}
